import type {SerializedGraph} from 'graphology-types';

export const LEGACY_GRAPH_VERSION = '0.0.1';

export interface SerializedStore {
  version: string;
  hierarchy: Record<string, string[]>;
  graph: SerializedGraph;
  metadata: Record<string, unknown>;
}

export enum BuilderEventTags {
  INITIALIZED_STORE = 'initialized-store',
  CREATE_NODE = 'create-node',
  PUT_NODE = 'put-node',
  MOVE_NODE = 'move-node',
  PUT_EDGE = 'put-edge',
  PUT_LEVEL = 'put-level',
  REMOVE_NODE = 'remove-node',
  REMOVE_EDGE = 'remove-edge',
}

/**
 * Tag value for node move messages.
 */
export type BuilderMoveNodePayload = {
  node: string;
  level: string;
  index: number;
};

/**
 * Used for deletion of atoms.
 */
export type BuilderRemoveAtomPayload = {
  atomId: string;
};

/**
 * Used by audience edge and node objects to update an
 * audience graph, using an adapter.
 */
export * from './classic_builder/types.js';
export * from './types.js';
